import { X, Loader2 } from "lucide-react";
import { Button } from '../../../components/ui/button';

interface DeleteAgentModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  agentName: string;
  loading?: boolean;
}

export function DeleteAgentModal({ open, onClose, onConfirm, agentName, loading }: DeleteAgentModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-[20px] shadow-xl w-full max-w-md mx-4 overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-foreground font-montserrat text-xl font-bold">
            ¿Desconectar agente?
          </h2>
          <button
            onClick={onClose}
            className="text-foreground/60 hover:text-foreground transition-colors"
            disabled={loading}
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <p className="text-foreground/80 font-montserrat text-base">
            Estás a punto de desconectar el agente <span className="font-bold">"{agentName}"</span>
          </p>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-blue-800 font-montserrat text-sm font-semibold mb-2">
              ℹ️ El workflow y el canal se mantendrán
            </p>
            <p className="text-blue-700 font-montserrat text-sm">
              Solo se desconectará de esta sección. Podrás encontrar:
            </p>
            <ul className="mt-2 space-y-1 text-blue-700 font-montserrat text-sm">
              <li>✓ El workflow en la página de Workflows</li>
              <li>✓ El canal en la sección de Canales</li>
              <li>✓ Todos los mensajes y configuraciones intactos</li>
            </ul>
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-6 bg-grey-50 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={loading}
            className="flex-1"
          >
            Cancelar
          </Button>
          <Button
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 bg-primary hover:bg-primary/90 text-black"
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin mr-2" />
                Desconectando...
              </>
            ) : 'Desconectar'}
          </Button>
        </div>
      </div>
    </div>
  );
}
